import { CTA } from '@volkswagen-onehub/components-core';
import { GlobalStoreStateConfiguration } from '@/stores/globalStore';
import { fuelType } from '@/modules/constants/fuelType';
import {
  configurationsContainsFuelType,
  getBuildableConfigs,
} from '@/modules/utils/storeUtils';
import { useTribalContext } from '@/context/tribal';

const EngineAndTransmissionTsAndCs = ({
  configurations,
}: {
  configurations: GlobalStoreStateConfiguration[];
}) => {
  const { contentManager } = useTribalContext();

  const validConfigurations = getBuildableConfigs(configurations);

  const containsDieselCar = configurationsContainsFuelType(
    fuelType.DIESEL,
    validConfigurations
  );

  return (
    <>
      {containsDieselCar ? (
        <div>
          {contentManager.get('adblue-terms-and-conditions-1')}{' '}
          <CTA
            tag="a"
            emphasis="tertiary"
            href={contentManager.get('adblue-terms-and-conditions-href')}
          >
            {contentManager.get('adblue-terms-and-conditions-2')}
          </CTA>{' '}
          {contentManager.get('adblue-terms-and-conditions-3')}`
        </div>
      ) : null}
    </>
  );
};

export default EngineAndTransmissionTsAndCs;
